import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { MenuConfig, OutlineType, ToolbarConfig } from '@tencent/workbench';
import * as React from 'react';
import { TOOLBAR_CLEARFORMAT, TOOLBAR_FORECOLOR } from '@editor/src/img/pageIndex';
import { config } from '@framework/workbench/ui/insert/insert-table/config';
import FONT_EFFECT from '@tencent/docs-design-resources/icon/desktop/svg/text_effect_light_24.svg';
import FONT_BORDER from '@tencent/docs-design-resources/icon/desktop/svg/text_outline_light_24.svg';
import MERGE_CELL from '@tencent/docs-design-resources/icon/desktop/svg/merge_cells_24.svg';
import CANCEL_CELL from '@tencent/docs-design-resources/icon/desktop/svg/merge_cells_cancel_24.svg';
import DELETE_TABLE from '@tencent/docs-design-resources/icon/desktop/svg/delete_table_range_light_24.svg';
import INSERT_UP from '@tencent/docs-design-resources/icon/desktop/svg/add_row_up_outline_light_24.svg';
import INSERT_DOWN from '@tencent/docs-design-resources/icon/desktop/svg/add_row_down_outline_light_24.svg';
import INSERT_LEFT from '@tencent/docs-design-resources/icon/desktop/svg/add_list_left_outline_light_24.svg';
import INSERT_RIGHT from '@tencent/docs-design-resources/icon/desktop/svg/add_list_right_outline_light_24.svg';
import AVERAGE_ROW from '@tencent/docs-design-resources/icon/desktop/svg/average_row_height_light_24.svg';
import AVERAGE_COL from '@tencent/docs-design-resources/icon/desktop/svg/average_list_width_light_24.svg';
import PAGEMARGINS from '@tencent/docs-design-resources/icon/desktop/svg/pagemargins_outline_light_24.svg';
import STRAIGHT from '@tencent/docs-design-resources/icon/desktop/svg/straight_font_outline_light_24.svg';
import { wrapIdForCustomContent } from '@framework/workbench/util/wrap-id-util';
import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import TEXT1 from '@tencent/docs-design-resources/image/desktop/png@2x/text_direction_horizontal_48@2x.png';
import TEXT2 from '@tencent/docs-design-resources/image/desktop/png@2x/text_direction_vertical_48@2x.png';
import TEXT3 from '@tencent/docs-design-resources/image/desktop/png@2x/text_direction_90rotate_48@2x.png';
import TEXT4 from '@tencent/docs-design-resources/image/desktop/png@2x/text_direction_270rotate_48@2x.png';
import TEXT5 from '@tencent/docs-design-resources/image/desktop/png@2x/text_direction_pile_48@2x.png';

export const styleConfig = {
    id: ActionType.TABLE_STYLE_PANEL,
};

export const titleConfig = {
    id: ActionType.TABLE_TITLE_LINE,
};

export const firstConfig = {
    id: ActionType.TABLE_FIRST_LINE,
};

export const totalConfig = {
    id: ActionType.TABLE_TOTAL_LINE,
};

export const lastConfig = {
    id: ActionType.TABLE_LAST_LINE,
};

export const edgeRowConfig = {
    id: ActionType.TABLE_EDGE_ROW,
};

export const edgeColConfig = {
    id: ActionType.TABLE_EDGE_COL,
};

export const quickConfig = {
    id: ActionType.TABLE_QUICK_SETTING,
};

export const clearConfig = {
    id: ActionType.TABLE_CLEAR,
    content: i18n.t('清除表格'),
};

export const mergeCellToolbar = {
    id: ActionType.MERGE_CELL_TOOLBAR,
    content: i18n.t('合并单元格'),
    icon: MERGE_CELL,
};

export const cancelCellToolbar = {
    id: ActionType.CANCEL_CELL_TOOLBAR,
    content: i18n.t('拆分单元格'),
    icon: MERGE_CELL,
};

export const mergeCellToolbarText = {
    id: ActionType.MERGE_CELL_TOOLBAR_TEXT,
    content: i18n.t('合并单元格'),
    icon: MERGE_CELL,
};

export const cancelCellToolbarText = {
    id: ActionType.CANCEL_CELL_TOOLBAR_TEXT,
    content: i18n.t('拆分单元格'),
    icon: CANCEL_CELL,
};

export const mergeCellAndSelectText = {
    id: ActionType.MERGE_CELL_AND_SELECT,
    content: i18n.t('合并单元格并居中'),
    icon: CANCEL_CELL,
};

export const borderStyleSelectionToolbar = {
    id: ActionType.BORDER_STYLE_TOOLBAR,
    content: i18n.t('线条类型'),
};

export const borderWidthSelectionToolbar = {
    id: ActionType.BORDER_WIDTH_TOOLBAR,
    content: i18n.t('线条粗细'),
};

export const insertTopToolbar = {
    id: ActionType.INSERT_TOP_TOOLBAR,
    content: i18n.t('在上方插入行'),
    icon: INSERT_UP,
};

export const insertBottomToolbar = {
    id: ActionType.INSERT_BOTTOM_TOOLBAR,
    content: i18n.t('在下方插入行'),
    icon: INSERT_DOWN,
};

export const insertLeftToolbar = {
    id: ActionType.INSERT_LEFT_TOOLBAR,
    content: i18n.t('在左侧插入列'),
    icon: INSERT_LEFT,
};

export const insertRightToolbar = {
    id: ActionType.INSERT_RIGHT_TOOLBAR,
    content: i18n.t('在右侧插入列'),
    icon: INSERT_RIGHT,
};

export const sharingRowConfig = {
    id: ActionType.TABLE_SHARING_ROW,
    content: i18n.t('均分行高'),
    icon: AVERAGE_ROW,
};

export const sharingColConfig = {
    id: ActionType.TABLE_SHARING_COL,
    content: i18n.t('均分列宽'),
    icon: AVERAGE_COL,
};

export const rowHeightToolbarConfig = {
    id: ActionType.TABLE_ROW_HEIGHT,
    content: i18n.t('行高'),
};

export const colWidthToolbarConfig = {
    id: ActionType.TABLE_COL_WIDTH,
    content: i18n.t('列宽'),
};

export const tableMarginToolbarConfig = {
    id: ActionType.TABLE_FONT_MARGIN,
    content: i18n.t('单元格边距'),
    icon: PAGEMARGINS,
};

export const tableMarginMenuNormalConfig = {
    id: ActionType.TABLE_FONT_MARGIN_NORMAL,
    content: i18n.t('默认'),
};

export const tableMarginMenuBigConfig = {
    id: ActionType.TABLE_FONT_MARGIN_BIG,
    content: i18n.t('较宽'),
};

export const tableMarginMenuSmallConfig = {
    id: ActionType.TABLE_FONT_MARGIN_SMALL,
    content: i18n.t('较窄'),
};

export const tableMarginMenuNoneConfig = {
    id: ActionType.TABLE_FONT_MARGIN_NONE,
    content: i18n.t('无边距'),
};

export const tableFontDirectionToolbarConfig = {
    id: ActionType.TABLE_FONT_DIRECTION,
    content: i18n.t('文字方向'),
    icon: STRAIGHT,
};

export const tableFontDirectionHoriConfig = {
    id: TextDirectionType.HORIZONTAL,
    content: i18n.t('横排'),
    icon: TEXT1,
};

export const tableFontDirectionVertConfig = {
    id: TextDirectionType.VERTICAL,
    content: i18n.t('竖排'),
    icon: TEXT2,
};

export const tableFontDirection90Config = {
    id: TextDirectionType.ROTATE_90,
    content: i18n.t('将所有文字旋转 90°'),
    icon: TEXT3,
};

export const tableFontDirection270Config = {
    id: TextDirectionType.ROTATE_270,
    content: i18n.t('将所有文字旋转 270°'),
    icon: TEXT4,
};

export const tableFontDirectionStackConfig = {
    id: TextDirectionType.WORD_ART_VERTICAL_GENERAL,
    content: i18n.t('堆积'),
    icon: TEXT5,
};

export const tableAnchorConfig = {
    id: ActionType.TABLE_FONT_DIRECTION,
    content: i18n.t('对齐'),
    icon: TEXT5,
};

export const deleteTableToolbar = {
    id: ActionType.DELETE_TABLE_TOOLBAR,
    content: i18n.t('删除'),
    icon: DELETE_TABLE,
};

export const deleteTableRowToolbar = {
    id: ActionType.DELETE_ROW,
    content: i18n.t('删除所在行'),
};

export const deleteTableColToolbar = {
    id: ActionType.DELETE_COL,
    content: i18n.t('删除所在列'),
};

export const deleteAllTableColToolbar = {
    id: ActionType.DELETE_TABLE,
    content: i18n.t('删除整个表格'),
};

export const cellRowHeightConfig = {
    id: ActionType.TABLE_ROW_HEIGHT_TOOLBAR,
    content: i18n.t('行高'),
};

export const cellColWidthConfig = {
    id: ActionType.TABLE_COL_WIDTH_TOOLBAR,
    content: i18n.t('列宽'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: deleteTableToolbar.id,
        content: deleteTableToolbar.content,
        tooltip: deleteTableToolbar.content,
    },
    {
        name: deleteTableRowToolbar.id,
        content: deleteTableRowToolbar.content,
        tooltip: deleteTableRowToolbar.content,
    },
    {
        name: deleteTableColToolbar.id,
        content: deleteTableColToolbar.content,
        tooltip: deleteTableColToolbar.content,
    },
    {
        name: deleteAllTableColToolbar.id,
        content: deleteAllTableColToolbar.content,
        tooltip: deleteAllTableColToolbar.content,
    },
    {
        name: mergeCellToolbarText.id,
        tooltip: mergeCellToolbarText.content,
        content: mergeCellToolbarText.content,
    },
    {
        name: cancelCellToolbarText.id,
        tooltip: cancelCellToolbarText.content,
        content: cancelCellToolbarText.content,
    },
    {
        name: mergeCellAndSelectText.id,
        tooltip: mergeCellAndSelectText.content,
        content: mergeCellAndSelectText.content,
    },
    {
        name: mergeCellToolbar.id,
        tooltip: mergeCellToolbar.content,
        content: mergeCellToolbar.content,
    },
    {
        name: cancelCellToolbar.id,
        tooltip: cancelCellToolbar.content,
        content: cancelCellToolbar.content,
    },
    {
        name: tableMarginToolbarConfig.id,
        tooltip: tableMarginToolbarConfig.content,
        content: tableMarginToolbarConfig.content,
    },
    {
        name: tableMarginMenuBigConfig.id,
        tooltip: tableMarginMenuBigConfig.content,
        content: tableMarginMenuBigConfig.content,
    },
    {
        name: tableMarginMenuSmallConfig.id,
        tooltip: tableMarginMenuSmallConfig.content,
        content: tableMarginMenuSmallConfig.content,
    },
    {
        name: tableMarginMenuNormalConfig.id,
        tooltip: tableMarginMenuNormalConfig.content,
        content: tableMarginMenuNormalConfig.content,
    },
    {
        name: tableMarginMenuNoneConfig.id,
        tooltip: tableMarginMenuNoneConfig.content,
        content: tableMarginMenuNoneConfig.content,
    },
    {
        name: tableFontDirectionToolbarConfig.id,
        tooltip: tableFontDirectionToolbarConfig.content,
        content: tableFontDirectionToolbarConfig.content,
    },
    {
        name: tableFontDirectionHoriConfig.id,
        tooltip: tableFontDirectionHoriConfig.content,
        content: <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        }}>
            <img src={tableFontDirectionHoriConfig.icon} style={{
                width: 48,
                height: 32,
            }} />
            <div
                style={{
                    marginLeft: 8,
                }}
            >{
                    tableFontDirectionHoriConfig.content
                }</div>
        </div>,
    },
    {
        name: tableFontDirectionStackConfig.id,
        tooltip: tableFontDirectionStackConfig.content,
        content: <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        }}>
            <img src={tableFontDirectionStackConfig.icon} style={{
                width: 48,
                height: 32,
            }} />
            <div
                style={{
                    marginLeft: 8,
                }}
            >{
                    tableFontDirectionStackConfig.content
                }</div>
        </div>,
    },
    {
        name: tableFontDirectionVertConfig.id,
        tooltip: tableFontDirectionVertConfig.content,
        content: <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        }}>
            <img src={tableFontDirectionVertConfig.icon} style={{
                width: 48,
                height: 32,
            }} />
            <div
                style={{
                    marginLeft: 8,
                }}
            >{
                    tableFontDirectionVertConfig.content
                }</div>
        </div>,
    },
    {
        name: tableFontDirection90Config.id,
        tooltip: tableFontDirection90Config.content,
        content: <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        }}>
            <img src={tableFontDirection90Config.icon} style={{
                width: 48,
                height: 32,
            }} />
            <div
                style={{
                    marginLeft: 8,
                }}
            >{
                    tableFontDirection90Config.content
                }</div>
        </div>,
    },
    {
        name: tableFontDirection270Config.id,
        tooltip: tableFontDirection270Config.content,
        content: <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        }}>
            <img src={tableFontDirection270Config.icon} style={{
                width: 48,
                height: 32,
            }} />
            <div
                style={{
                    marginLeft: 8,
                }}
            >{
                    tableFontDirection270Config.content
                }</div>
        </div>,
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: styleConfig.id,
        preventHighlight: true,
    },
    {
        name: titleConfig.id,
        text: i18n.t('标题行'),
        tooltip: i18n.t('标题行'),
    },
    {
        name: totalConfig.id,
        text: i18n.t('汇总行'),
        tooltip: i18n.t('汇总行'),
    },
    {
        name: firstConfig.id,
        text: i18n.t('第一列'),
        tooltip: i18n.t('第一列'),
    },
    {
        name: lastConfig.id,
        text: i18n.t('结尾列'),
        tooltip: i18n.t('结尾列'),
    },
    {
        name: edgeRowConfig.id,
        text: i18n.t('镶边行'),
        tooltip: i18n.t('镶边行'),
    },
    {
        name: edgeColConfig.id,
        text: i18n.t('镶边列'),
        tooltip: i18n.t('镶边列'),
    },
    {
        name: quickConfig.id,
        shrinkable: 'steps',
        style: {
            width: 'auto',
        },

        shrinkSteps: [312, 384, 456],
        widthRange: [240, 528],
        preventHighlight: true,
    },
    {
        name: clearConfig.id,
        icon: <img src={TOOLBAR_CLEARFORMAT} alt={''}/>,
        tooltip: i18n.t('清除样式'),
        text: clearConfig.content,
    },
    {
        name: mergeCellToolbar.id,
        tooltip: i18n.t('合并单元格'),
        icon: <img src={mergeCellToolbar.icon} alt={''} />,
        hasArrow: true,
    },
    {
        name: borderStyleSelectionToolbar.id,
        tooltip: borderStyleSelectionToolbar.content,
    },
    {
        name: borderWidthSelectionToolbar.id,
        tooltip: borderWidthSelectionToolbar.content,
    },
    {
        name: deleteTableToolbar.id,
        tooltip: deleteTableToolbar.content,
        icon: <img src={deleteTableToolbar.icon} alt={''}/>,
        text: deleteTableToolbar.content,
        style: {
        },
    },
    {
        name: insertTopToolbar.id,
        tooltip: insertTopToolbar.content,
        icon: <img src={insertTopToolbar.icon} alt={''}/>,
        text: insertTopToolbar.content,
    },
    {
        name: insertBottomToolbar.id,
        tooltip: insertBottomToolbar.content,
        icon: <img src={insertBottomToolbar.icon} alt={''}/>,
        text: insertBottomToolbar.content,
    },
    {
        name: insertLeftToolbar.id,
        tooltip: insertLeftToolbar.content,
        icon: <img src={insertLeftToolbar.icon} alt={''}/>,
        text: insertLeftToolbar.content,
    },
    {
        name: insertRightToolbar.id,
        tooltip: insertRightToolbar.content,
        icon: <img src={insertRightToolbar.icon} alt={''}/>,
        text: insertRightToolbar.content,
    },
    {
        name: mergeCellToolbarText.id,
        tooltip: mergeCellToolbarText.content,
        text: mergeCellToolbarText.content,
        icon: <img src={mergeCellToolbarText.icon}/>,
    },
    {
        name: cancelCellToolbarText.id,
        tooltip: cancelCellToolbarText.content,
        text: cancelCellToolbarText.content,
        icon: <img src={cancelCellToolbarText.icon}/>,
    },
    {
        name: sharingRowConfig.id,
        tooltip: sharingRowConfig.content,
        icon: <img src={sharingRowConfig.icon} alt={''}/>,
        text: sharingRowConfig.content,
    },
    {
        name: sharingColConfig.id,
        tooltip: sharingColConfig.content,
        icon: <img src={sharingColConfig.icon} alt={''}/>,
        text: sharingColConfig.content,
    },
    {
        name: tableMarginToolbarConfig.id,
        tooltip: tableMarginToolbarConfig.content,
        icon: <img src={tableMarginToolbarConfig.icon} alt={''}/>,
        text: tableMarginToolbarConfig.content,
        style: {
        },
    },
    {
        name: tableFontDirectionToolbarConfig.id,
        tooltip: tableFontDirectionToolbarConfig.content,
        icon: <img src={tableFontDirectionToolbarConfig.icon} alt={''}/>,
        text: tableFontDirectionToolbarConfig.content,
        style: {
        },
    },
    {
        name: cellRowHeightConfig.id,
        tooltip: cellRowHeightConfig.content,
        text: cellRowHeightConfig.content,
        preventHighlight: true,
    },
    {
        name: cellColWidthConfig.id,
        tooltip: cellColWidthConfig.content,
        text: cellColWidthConfig.content,
        preventHighlight: true,
    },
];

